import { combineReducers } from 'redux';

import * as actionTypes from '@store/common/action-types';

export const initialFilters = {
	supplierId: '',
	categoryIdList: [],
	marketIdList: [],
	tagIdList: [],
	fixedTagIdList: [],
	colorList: [],
	fabricTypes: [],
	constructions: [],
	compositions: [],
	fabricCompositionPartIdList: [],
	trimsTypes: [],
	yarnCount: '',
	gauge: '',
	maxGsm: '',
	minGsm: '',
	embellishmentCategories: [],
	embellishmentSubCategories: [],
	trimsCategories: [],
	subCategory: [],
	suppliers: [],
	trimsSubCategories: [],
	mainCategoryIds: [],
	subCategoryIds: [],
	materialQualityIds: [],
	sustainabilityIds: [],
	specificBrandIds: [],
	brandIds: [],
	nominatedBrandIds: [],
	pricePointList: [],
	supplierType: [],
	brandingCategories: [],
	brandingSubCategories: [],
	brandingTypes: [],
	washProcesses: [],
	materialIdList: [],
	baseList: [],
	status: '',
	name: '',
	supplierCategory: [],
	haveEtp: false,
	haveLab: false,
	haveRnd: false,
	haveSample: false,
	haveStudio: false,
	haveWtp: false,
	isComposite: false,
	minimumRating: '',
	certificateTypeList: [],
	productStrengthTagList: [],
	additionalTagList: [],
	seasonList: [],
	clientTagList: [],
	maxAccordScore: '',
	minAccordScore: '',
	maxLine: '',
	minLine: '',
	cityId: '',
	countryId: '',
	countryIds: [],
	search: '',
	sort: 'id,desc',
	isFilter: false,
	sortInDesignTool: false,
	productIdToSort: '',
	page: 0
};

const filters = (state = initialFilters, { type, payload }) => {
	switch (type) {
		case actionTypes.SET_FILTERS:
			return payload;
		default:
			return state;
	}
};

const filterReducer = combineReducers({
	filters
});

export default filterReducer;
